// Cupom automático de campanha: um por período, aplicado a todos (mesmo sem launchPin).
// Usa o mesmo mecanismo do lançamento (launchCouponCode, aplicado em CartPage.jsx).
// Para uma nova campanha, basta adicionar uma entrada aqui; o cupom precisa existir no
// backend (orders/validate-coupon) com o mesmo percentual.
export const CAMPAIGN_COUPONS = [
  { code: "outubro", percent: 5, start: "2026-10-01T00:00:00-03:00", end: "2026-10-31T23:59:59-03:00" },
  { code: "black", percent: 5, start: "2026-11-01T00:00:00-03:00", end: "2026-11-30T23:59:59-03:00" },
];

const sameCode = (a, b) => String(a || "").toLowerCase() === String(b || "").toLowerCase();

export function isCampaignCouponCode(code) {
  return CAMPAIGN_COUPONS.some((c) => sameCode(c.code, code));
}

export function isCampaignActive(code, now = new Date()) {
  const active = getActiveCampaignCoupon(now);
  return active ? sameCode(active.code, code) : false;
}

export function getActiveCampaignCoupon(now = new Date()) {
  // Com períodos sobrepostos vale a que começou por último (a data inicial do seguinte
  // encerra a anterior), independente da ordem da lista.
  return CAMPAIGN_COUPONS
    .filter((c) => now >= new Date(c.start) && now <= new Date(c.end))
    .sort((a, b) => new Date(b.start) - new Date(a.start))[0] || null;
}

// Cupom de campanha que já não é o vigente (de um período anterior ou posterior).
function isStaleCampaignCode(code, active) {
  return isCampaignCouponCode(code) && !(active && sameCode(active.code, code));
}

// Reaplica a cada carregamento/mudança de página. Sempre invalida o cupom de campanha
// de outro período, inclusive o já aplicado ("coupon"), que ficaria preso no localStorage.
// O da Live (Lancamento.jsx) e qualquer cupom explícito (REENCONTRO, UNIVERSARIO26...)
// não são campanha e prevalecem.
export function ensureCampaignCoupon() {
  const active = getActiveCampaignCoupon();
  try {
    ["coupon", "shoppingCoupon"].forEach((key) => {
      try {
        const saved = JSON.parse(localStorage.getItem(key) || "null");
        if (saved && isStaleCampaignCode(saved.code, active)) localStorage.removeItem(key);
      } catch {}
    });

    const code = localStorage.getItem("launchCouponCode");
    if (isStaleCampaignCode(code, active)) {
      localStorage.removeItem("launchCouponCode");
      localStorage.removeItem("launchCouponPercent");
    }
    if (!active) return;

    // Cupom explícito (link, digitado ou já aplicado) prevalece: não mexe em nada.
    // O CartPage remove o percentual depois de aplicar o cupom (evita exibir em dobro).
    if (localStorage.getItem("pendingCouponCode") || localStorage.getItem("coupon")) return;

    const current = localStorage.getItem("launchCouponCode");
    if (!current) {
      localStorage.setItem("launchCouponCode", active.code);
      localStorage.setItem("launchCouponPercent", String(active.percent));
    } else if (sameCode(current, active.code) && !localStorage.getItem("launchCouponPercent")) {
      // Estado deixado por uma validação que falhou (ex.: cupom ainda não criado).
      localStorage.setItem("launchCouponPercent", String(active.percent));
    }
  } catch {
    // storage indisponível: sem desconto automático
  }
}
